export default __webpack_public_path__ + "static/media/UPP-Logotype-Landscape-White-Transparent.b6c7bdba.png";